import setShappyParamsImport from './setShappyParams'
import setShappyInfoImport from './setShappyInfo'
import setShopStatusImport from './setShopStatus'

export const setShappyParams = setShappyParamsImport
export const setShappyInfo = setShappyInfoImport
export const setShopStatus = setShopStatusImport



// WEBPACK FOOTER //
// ./src/store/modules/shappy/mutations/index.js